export const formatMoney = (n, currency = "£") => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  if (n >= 1e9) return `${currency}${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `${currency}${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `${currency}${(n / 1e3).toFixed(0)}k`;
  return `${currency}${n}`;
};

export const formatPct = (n) => (n === null || n === undefined || isNaN(n) ? "—" : `${n}%`);

export const formatNumber = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-GB").format(n);
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(iso);
};
